module.exports = __webpack_public_path__ + "static/media/27.7f5610c0.jpg";